import { render, staticRenderFns } from "./kycAuth.vue?vue&type=template&id=6df6357a&scoped=true&"
import script from "./kycAuth.vue?vue&type=script&lang=js&"
export * from "./kycAuth.vue?vue&type=script&lang=js&"
import style0 from "./kycAuth.vue?vue&type=style&index=0&id=6df6357a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df6357a",
  null
  
)

export default component.exports